var _defs, _g, _g2, _g3, _g4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsViewProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        .cls-view-1,.cls-view-2{fill:none;}\n        .cls-view-1{clip-rule:evenodd;}\n        .cls-view-3{clip-path:url(#clip-path);}\n        .cls-view-4{clip-path:url(#clip-path-2);}\n        .cls-view-5{clip-path:url(#clip-path-3);}\n        .cls-view-6{clip-path:url(#clip-path-4);}\n        .cls-view-7{isolation:isolate;}\n        .cls-view-8{clip-path:url(#clip-path-5);}\n        .cls-view-9{clip-path:url(#clip-path-6);}\n        .cls-view-10{clip-path:url(#clip-path-7);}\n        .cls-view-11{fill:currentColor;}\n        .cls-view-12{clip-path:url(#clip-path-8);}\n        .cls-view-13{clip-path:url(#clip-path-9);}\n        .cls-view-14{clip-path:url(#clip-path-10);}\n        .cls-view-15{clip-path:url(#clip-path-12);}\n        .cls-view-16{clip-path:url(#clip-path-14);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-view-1",
    d: "M170.06,25.57h-21A1.09,1.09,0,0,1,148,24.48v-21a1.09,1.09,0,0,1,1.09-1.09h10.75a1.09,1.09,0,0,1,0,2.17h-9.67V23.4H169V15.09a1.09,1.09,0,1,1,2.17,0v9.39a1.08,1.08,0,0,1-1.08,1.09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-view-1",
    d: "M160.05,19.57H160l-3.87-.26a1.06,1.06,0,0,1-1-1l-.26-3.87a1,1,0,0,1,.31-.82L166.05,2.74a1.07,1.07,0,0,1,1.51,0l4.13,4.13a1.06,1.06,0,0,1,.31.75,1,1,0,0,1-.31.75L160.8,19.26A1.06,1.06,0,0,1,160.05,19.57Zm-2.87-2.32,2.46.16,9.79-9.79L166.81,5,157,14.79Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-view-1",
    d: "M306.21,3.36a4.74,4.74,0,0,0-6.36,2.39,5.69,5.69,0,0,0,0,3.82,4.77,4.77,0,0,0,5.91,2.55,5.28,5.28,0,0,0,2.6-2.33,5.47,5.47,0,0,0,.26-3.72A5.51,5.51,0,0,0,306.21,3.36Zm-2.93-2.1a6.33,6.33,0,0,1,6.33,2.93,6.52,6.52,0,0,1-1.54,8.6A5.34,5.34,0,0,1,304.16,14a4.12,4.12,0,0,1-2.68-.54,6.45,6.45,0,0,1,1.8-12.2ZM315.69,10,317,11.27l-2,2,2,1.93-.56.58a2.15,2.15,0,0,1-.74.57,4.94,4.94,0,0,1-1.06-.9l-.9-.91-.95.92-.94.94-.63-.5c-.35-.29-.62-.57-.62-.67a4.82,4.82,0,0,1,.91-1.07l.92-.89-.92-.92a5.77,5.77,0,0,1-.91-1.06,2.68,2.68,0,0,1,.56-.71l.57-.58,2,2Zm-19,2.4h0c.05.06.28.39.49.7l.38.57-.79.76c-1.72,1.66-2,2.68-2,7,0,2.67,0,3.18.23,3.38s1,.22,6.76.23h3.6c5.94,0,7.95-.05,8.07-.17a10.13,10.13,0,0,0,.18-3V19h1.78v3.26c0,3.12-.15,3.54-1.14,4.16l-.57.36-9,0H301c-3.68,0-5.62-.05-6-.13a2.07,2.07,0,0,1-1.3-.74c-.52-.57-.67-.95-.68-2.82v-.42c0-.53,0-1.15,0-1.9a15.26,15.26,0,0,1,.33-4l.05-.18a8.49,8.49,0,0,1,2.33-3.51c.48-.43.91-.74,1-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-2",
    width: 19.2,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-2",
    x: -1,
    y: -1,
    width: 21,
    height: 25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-view-1",
    d: "M6.14,5.34v.92H4.23l.91-.92,1-.92A4.16,4.16,0,0,1,6.14,5.34ZM7,.14C6.81.2,5.17,1.78,3.34,3.61L0,7V23.25l.38.37L.74,24H11.21V21.55H2.45V8.7H5.12c2.46,0,2.69,0,3.06-.32l.42-.3,0-2.79,0-2.78,4.05,0,4,0V15.28H19.2V8.11c0-3.95-.05-7.3-.09-7.43C18.86,0,18.42,0,12.72,0,9.73,0,7.15.06,7,.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-2",
    width: 20,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-view-1",
    points: "3.25 11.59 3.29 12.8 14.31 12.8 14.36 11.59 14.4 10.4 3.2 10.4 3.25 11.59"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-2",
    x: -1360,
    y: -239,
    width: 1528,
    height: 860
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-view-1",
    points: "3.25 14.79 3.29 16 14.31 16 14.36 14.79 14.4 13.6 3.2 13.6 3.25 14.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-view-1",
    d: "M18.13,18.5a3.06,3.06,0,0,1,1.95,1.94,2.93,2.93,0,0,1-4,3.53,2.73,2.73,0,0,1-1.7-2.71,2.79,2.79,0,0,1,1.86-2.7A2.7,2.7,0,0,1,18.13,18.5Zm-2-2.39a5.35,5.35,0,0,0-3.46,7.71,5.16,5.16,0,0,0,2.48,2.33,6,6,0,0,0,4.28,0l.78-.35L22.37,28l.82-.8.81-.8-1.12-1.13-1.13-1.13.34-.64a6.74,6.74,0,0,0,.3-3.61,5.81,5.81,0,0,0-1.86-2.76A5.71,5.71,0,0,0,16.09,16.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-view-1",
    d: "M221.82,7a4.83,4.83,0,0,0,0,3.25,4.05,4.05,0,0,0,5,2.16,4.46,4.46,0,0,0,2.21-2,4.67,4.67,0,0,0,.22-3.15A4.73,4.73,0,0,0,227.21,5,4,4,0,0,0,221.82,7Zm8.28-1.32a5.53,5.53,0,0,1-1.3,7.3,4.57,4.57,0,0,1-3.33,1,3.49,3.49,0,0,1-2.27-.46,5.45,5.45,0,0,1-2.55-7.38,5.56,5.56,0,0,1,4.07-3A5.38,5.38,0,0,1,230.1,5.67Zm8.23,4.46a.92.92,0,0,1,.88,0,1.16,1.16,0,0,1,.79,1.16v.06c0,.53.05.46-3.54,4.23-3.35,3.53-3.56,3.78-4,3.79h-.25c-.58,0-.73-.14-2-1.77s-1.4-1.78-1.4-2.11a1.35,1.35,0,0,1,.8-1.16c.69-.3,1-.14,1.95,1,.47.54.85,1,.86,1,.16-.22,1.48-1.6,2.84-3l.37-.38,1.07-1.08.33-.33C237.71,10.7,238.26,10.16,238.33,10.13Zm-19.2,2.51h0l.35.5.06.09.33.49-.67.64c-1.46,1.41-1.71,2.28-1.71,5.94,0,2.26,0,2.7.2,2.86l0,0,0,0c.27.12,1.28.15,5.66.15h3.06c5.05,0,6.75,0,6.85-.15a7.23,7.23,0,0,0,.15-2.35v-.95H235V21c0,2.57-.12,3-.9,3.49l-.07.05-.48.3-7.61,0h-3.15c-3.12,0-4.77,0-5.13-.11a1.81,1.81,0,0,1-1.1-.63c-.44-.49-.57-.81-.58-2.4v-.36c0-.44,0-1,0-1.6a11.57,11.57,0,0,1,.33-3.57,7.17,7.17,0,0,1,2-3,3.17,3.17,0,0,1,.77-.58Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-view-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-view-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-view-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-view-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-view-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-11",
    x: -1,
    y: -1,
    width: 21.2,
    height: 26
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-view-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-view-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-11",
    x: 2.2,
    y: 9.4,
    width: 13.2,
    height: 4.4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-view-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-view-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-11",
    x: 2.2,
    y: 12.6,
    width: 13.2,
    height: 4.4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-view-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-view-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-11",
    x: 9.99,
    y: 14.78,
    width: 15.01,
    height: 14.22
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-view-2",
    x: -492,
    y: -79.5,
    width: 1528,
    height: 860
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsViewProfile);
export default __webpack_public_path__ + "static/media/icons_view_profile.f1449f80ca23c8f8c204b2846931b8a2.svg";
export { ForwardRef as ReactComponent };